const buildTaskHierarchy = (tasks) => {
  const tasksMap = new Map();
  const hierarchy = [];

  // Sort tasks based on taskType and folderId
  tasks.sort((a, b) => {
    if (a.folderId && !b.folderId) {
      return 1; // Folder comes after root task
    }
    if (!a.folderId && b.folderId) {
      return -1; // Root task comes before folder
    }
    return a.taskOrder - b.taskOrder; // Sort by taskOrder
  });

  tasks.forEach((task) => {
    task.children = [];
    tasksMap.set(task._id, task);
  });

  // Traverse the tasks and assign children to their parent folders
  tasks.forEach((task) => {
    if (task.folderId) {
      const parentTask = tasksMap.get(task.folderId);
      if (parentTask) {
        parentTask.children.push(task);
      }
    } else {
      hierarchy.push(task); // Task is at the root level
    }
  });

  if (hierarchy.length === 0 && tasks.length > 0) {
    return tasks;
  }

  return hierarchy;
};

const flattenHierarchy = (hierarchy, folderLevel = 0) => {
  const flattened = [];

  hierarchy.forEach((task) => {
    task.folderLevel = folderLevel;
    flattened.push(task);

    if (task.children && task.children.length) {
      const children = flattenHierarchy(task.children, folderLevel + 1);
      flattened.push(...children);
    }
  });

  return flattened;
};

const sortTaskWithFolders = (tasks) => {
  if (tasks.lenght <= 0) return tasks;
  // To avoid mutating jobTasks and infinit loop
  const hierarchy = buildTaskHierarchy([...tasks]);
  tasks = flattenHierarchy(hierarchy);
  return tasks;
};

module.exports = sortTaskWithFolders;
